import { createGlobalStyle } from 'styled-components';
import { theme } from 'design';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
  }

  #root {
    flex-direction: column;
  }
  body {
    position: relative;
    font-family: ${theme.font.family.euclid};
    font-weight: ${theme.font.weight.regular};
    /* off-scale exception: this is the rem base that toRem() divides against, not a scale step — changing it rescales every tokenized font-size in the app */
    font-size: 16px;
    /* off-scale exception: the inherited fallback, not a type role — a % here inherits as computed px, so a role's pairing would leak into every smaller text that sets none */
    line-height: 100%;
    font-variant: none;
    font-feature-settings: initial;
    color: ${theme.color.neutral[900]};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &.prevent-scroll {
      overflow: hidden;
    }
  }

  article, section, div, header, nav, main {
    display: flex;
  }

  form {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  form, fieldset {
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
  }

  input, select {
    width: 100%;
  }

  iframe {
    width: 100%;
    margin: 0 auto;
    padding: 0 0;
    border: none;
    outline: none;
  }

  a {
    color: ${theme.color.neutral[800]};
  }

  button {
    appearance: none;
    width: auto;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: none;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  ul, ol {
    margin: 0;
    padding: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export default GlobalStyles;
